import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommFilterJunctionOutZoneTable extends Layout {
    sourceMCFilterJunctionOutZone: DataSource;
    tableMCFilterJunctionOutZone: Table;
}
